import React from 'react';
import { useSelector } from 'react-redux';
import Immutable from 'immutable';
import {
  NavigationScroll,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CONTENT_TYPES } from '../../config/constants';
import useDossierIdParam from '../../hooks/useDossierIdUrlParam';

import {
  CampaignNavigation,
  ProgressBar,
  Submenu,
} from '..';

import Navigation from '../../implementations/Navigation';
import './style.scss';

const SUPPORTED_PROGRESS_BAR_TYPES = [
  'download',
  'article',
  'basic_page',
  'interventie',
  'praktijkvoorbeeld',
  'onderzoek',
  'milestones',
];

const Header = ({ pageRef }) => {
  // Current page entity
  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const currentEntity = useSelector((state) => state.getIn(['node', currentEntityId], Immutable.Map()));
  const currentEntityType = currentEntity.getIn(['type', 0, 'target_id'], '');
  const currentTaxonomyType = useSelector((state) => state.getIn(['taxonomyTerm', currentEntityId, 'vid', 0, 'target_id'], ''));

  // Campaign navigation
  const campaign = currentEntity.getIn(['field_campaign', 0, 'entity'], null);
  const campaignSlogan = currentEntity.getIn(['field_campaign', 0, 'entity', 'field_slogan', 0, 'value'], null);

  // Check if Submenu should be shown (on article or research page with dossier_id in URL)
  const dossierId = useDossierIdParam();
  const shouldShowSubmenu = dossierId && [CONTENT_TYPES.ARTICLE, CONTENT_TYPES.RESEARCH].includes(currentEntityType);

  return (
    <header className="Header" id="Header">
      <NavigationScroll>
        <>
          <Navigation />
          {(
            SUPPORTED_PROGRESS_BAR_TYPES.includes(currentEntityType)
            || SUPPORTED_PROGRESS_BAR_TYPES.includes(currentTaxonomyType)
          ) && (
            <ProgressBar scrollAreaRef={pageRef} />
          )}
          {(campaign && campaignSlogan) && (
            <CampaignNavigation slogan={campaignSlogan} />
          )}
        </>
      </NavigationScroll>
      {shouldShowSubmenu && <Submenu />}
    </header>
  );
};

export default Header;
